var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "button",
        {
          staticClass: "boss-button pega-button display-inline",
          attrs: { "data-test": "action-button", disabled: _vm.isDisabled },
          on: {
            click: function ($event) {
              return _vm.callMordalInner()
            },
          },
        },
        [_c("span", [_vm._v("面接場所を追加")])]
      ),
      _vm._v(" "),
      _c("entry-interview-place-modal-inner", { ref: "mordal_inner" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }